"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 배너, 알림, 토스트 등 비파괴적 해제 버튼.
 */
let DismissButton = class DismissButton extends (0, icon_button_utils_1.iconActionElement)({
    event: 'dismiss',
    icon: icon_names_1.ICON_NAMES.DISMISS,
    ariaLabel: '닫기',
}) {
};
DismissButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonSizeSkin)('small')}
      }
    `,
];
DismissButton = __decorate([
    (0, decorators_js_1.customElement)('mm-dismiss-button')
], DismissButton);
exports.DismissButton = DismissButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzbWlzcy1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJkaXNtaXNzLWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBeUI7QUFDekIscURBQWlEO0FBRWpELG9FQUFnRTtBQUNoRSwyRkFHMkQ7QUFDM0QseUZBQXFGO0FBQ3JGLCtEQUF5RDtBQUV6RDs7R0FFRztBQUVJLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxJQUFBLHFDQUFpQixFQUFDO0lBQ25ELEtBQUssRUFBRSxTQUFTO0lBQ2hCLElBQUksRUFBRSx1QkFBVSxDQUFDLE9BQU87SUFDeEIsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQzs7QUFDTyxvQkFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCxxQ0FBZ0I7SUFDaEIsSUFBQSxTQUFHLEVBQUE7O1VBRUcsSUFBQSx1Q0FBa0IsRUFBQyxPQUFPLENBQUM7O0tBRWhDO0NBQ0YsQ0FBQTtBQWJVLGFBQWE7SUFEekIsSUFBQSw2QkFBYSxFQUFDLG1CQUFtQixDQUFDO0dBQ3RCLGFBQWEsQ0FjekI7QUFkWSxzQ0FBYSJ9